import { render, staticRenderFns } from "./NewsPR.vue?vue&type=template&id=273d9f00&"
import script from "./NewsPR.vue?vue&type=script&lang=js&"
export * from "./NewsPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports